export default defineNuxtPlugin(async (nuxtApp) => {
    const { public: runtimeConfig } = useRuntimeConfig();

    nuxtApp.provide('pxUser', {
        stage: runtimeConfig.pxUserStage ?? runtimeConfig.appStage,
        tenant: runtimeConfig.appTenant,
        domain: runtimeConfig.appDomain,
    });
});
